import { useAuth } from "./AuthProvider";

export const Can = ({ module, fallback = null, children }) => {
  const { loaded, can } = useAuth();
  if (!loaded) return null;
  return can(module) ? children : fallback;
};

export default Can;
